export interface VoucherCSVRow {
  Name: string;
  Email: string;
  "Product Name": string;
  Amount: string;
  "Reference ID": string;
  "Expiry Date": string;
  "Gift Card Code": string;
  "Term and condition"?: string;
  "Currency Code": string;
}

export interface VoucherEmailerRequest {
  subject: string;
  message: string;
  logo_url?: string | null;
  template: string;
  recipients: VoucherCSVRow[];
}

export interface VoucherEmailerTestRequest {
  subject: string;
  message: string;
  logo_url?: string | null;
  template: string;
  test_emails: string[];
  sample_voucher: VoucherCSVRow;
}

export const EMAIL_TEMPLATES = [
  {
    id: "classic",
    name: "Classic",
    description: "Traditional design with clean layout",
  },
  {
    id: "modern",
    name: "Modern",
    description: "Vibrant gradient design with bold colors",
  },
];

export const CSV_HEADERS = [
  "Name",
  "Email",
  "Product Name",
  "Amount",
  "Reference ID",
  "Expiry Date",
  "Gift Card Code",
  "Term and condition",
  "Currency Code",
];
